import {Inject, Injectable} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {DOCUMENT} from '@angular/common';

export interface ITheme {
  baseColor?: string;
  darkerColor?: string;
  highlightColor?: string;
  highlightLess?: string;
  warning?: string;
  rowFocus?: string;
  toolBarFontColor?: string;
  toolBarIconColor?: string;
}

export type themeClass = 'dark-theme' | 'light-theme' | 'custom-theme' | 'system-theme';

const themeMap: any = {
  'light-theme': 1,
  'dark-theme': 2,
  'custom-theme': 3,
  'system-theme': 4,
  '1': 'light-theme',
  '2': 'dark-theme',
  '3': 'custom-theme',
  '4': 'system-theme',
};

@Injectable({
  providedIn: 'root',
})
export class ThemeService {
  highlightColor: BehaviorSubject<string> = new BehaviorSubject<string>(
    '#F2975B' // var(--color-orange-400)
  );
  isThemeSet = false;
  themeClass: themeClass = 'light-theme';
  theme$ = new BehaviorSubject(this.themeClass);

  constructor(@Inject(DOCUMENT) private document: Document) {
    const cachedTheme: string = localStorage.getItem('themeClass');

    this.setupSystemThemeListener();

    if (cachedTheme !== '1' && cachedTheme !== '2' && cachedTheme !== '3' && cachedTheme !== '4') {
      console.warn(
        'Unexpected theme class in localStorage. Setting the default theme'
      );
      this.setTheme(1);
    }
    if (cachedTheme) {
      this.setTheme(Number(cachedTheme));
    }
  }

  private setupSystemThemeListener(): void {
    const darkThemeMq: MediaQueryList = window.matchMedia("(prefers-color-scheme: dark)");

    darkThemeMq.addEventListener('change', (): void => {
      if (this.themeClass === 'system-theme') {
        this.setTheme(4);
      }
    });
  }

  setTheme(guitheme: number) {
    console.log('Setting theme', guitheme);
    localStorage.setItem('themeClass', String(guitheme));
    this.document.body.classList.remove('dark-theme');
    this.document.body.classList.remove('light-theme');
    this.document.body.classList.remove('custom-theme');
    this.document.body.classList.remove('system-theme');
    const themeClassName: themeClass = themeMap[String(guitheme)];
    if (themeClassName === 'system-theme') {
      const darkThemeMq: MediaQueryList = window.matchMedia("(prefers-color-scheme: dark)");
      if (darkThemeMq.matches) {
        this.document.body.classList.add('dark-theme');
      } else {
        this.document.body.classList.add('light-theme');
      }
    } else {
      this.document.body.classList.add(themeClassName);
    }
    this.themeClass = themeClassName;
    this.theme$.next(themeClassName);
  }

  applyTheme(evt: string) {
    this.setTheme(themeMap[evt]);
  }
}
